import { Tenant } from '@/types/common';

import { axios } from '@/api';

import { REQUEST } from '../constants/request';

export type ValidateRemediationCustomerRequestParams = {
  token: string;
  tenant: Tenant;
  jwe: string | null;
};

export type ValidateRemediationCustomerResponse = {
  data: {
    email: string;
    tenant: string;
    language?: string;
  };
};

export const validateRemediationCustomer = async ({
  token,
  tenant,
  jwe,
}: ValidateRemediationCustomerRequestParams) => {
  const result = await axios.post<
    ValidateRemediationCustomerRequestParams,
    ValidateRemediationCustomerResponse
  >(
    REQUEST.VALIDATE_REMEDIATION_CUSTOMER,
    {
      token,
      ...(jwe && { type: 'jwe' }),
    },
    {
      headers: {
        'x-tenant': tenant,
      },
    },
  );

  axios.defaults.headers.common['x-tenant'] = result.data.tenant.toLowerCase();

  return result.data;
};
